// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"123":"case","357":"casesFrame","794":"cases"}[chunkId] || chunkId) + "." + {"123":"7b94738f","190":"8353a112","357":"be7653fa","762":"8d5ead0a","794":"f7363eb5","865":"622c3c8e"}[chunkId] + ".css";
};